export const DEFAULT_TEMPLATE_NAME = '__main__'

export const HORIZON_SCOPE = 'hrzn'
